<template>
  <div>


    <div
      v-if="selectedLocation.isLoading"
      class="section"
    >
      <div class="loader" />
    </div>



    <template v-else-if="selectedLocation.storeId && menu.menuId">
      <div class="section section--half-y-padding">
        <h2 class="title title--2 center-550-down primary">
          Menu
        </h2>
      </div>

      <menu-list :is-read-only="true" />
    </template>



    <div
      v-else
      class="section"
    >
      <p class="message message--danger">
        Oops! We couldn't find a menu for this location. Please try re-scanning your QR code.
      </p>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import MenuList from '@/components/globals/menu-list/index.vue';

  export default {
    name: 'ReadOnlyMenuPage',

    components: {
      MenuList
    },

    metaInfo() {
      return {
        title: 'Menu'
      };
    },

    computed: {
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('menu', ['menu']),
      ...mapGetters('merchant', ['merchant'])
    },

    created() {
      this.createdHandler();
    },

    unmounted() {
      this.destroyedHandler();
    },

    methods: {
      createdHandler() {
        const menuType = this.$route.query.mt || 'DineIn';
        this.$store.commit('menu/SET_MENU_TYPE_OVERRIDE', menuType);
        this.$store.dispatch('menu/getMenu', { silent: true });
      },

      destroyedHandler() {
        this.$store.commit('menu/SET_MENU_TYPE_OVERRIDE', null);
      }
    }
  };
</script>
